import { useState, useEffect, useCallback } from "react";

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useAsyncDebounce } from "react-table";

import { AdminHeader } from "shared/components/common/AdminHeader";
import { Loading } from "shared/components/ui/Loading";
import { Chip, InputAdornment, Tooltip } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Icon
import { Search } from "@mui/icons-material";

import { ReactComponent as Edit } from "components/icon/svg/edit.svg";
import { ReactComponent as Delete } from "components/icon/svg/delete.svg";

// Redux
import { useLazyGetAdminsQuery } from "shared/redux/endpoints/admin";

//
import { useNavigate } from "react-router-dom";
//Utils
import moment from "moment";
import { toast } from "react-toastify";

// Img
import AvaImg from "assets/images/ava.png";
import AdvanceTable from "components/AdvancedTable/AdvanceTable";

const initialState = {
  page: 0,
  size: 10,
  sort: "created,desc",
  search: "",
};

const tableColumns = [
  { Header: "User name", accessor: "fullName", width: 250 },
  { Header: "Email", accessor: "email", width: 250 },
  // { Header: "Title", accessor: "title" },
  { Header: "User code", accessor: "userCode" },
  { Header: "Default center", accessor: "centerName" },
  { Header: "Status", accessor: "status", width: 100 },
  { Header: "Action", accessor: "action", width: 100 },
];

export default function AdminListPage() {
  const navigation = useNavigate();
  const [trigger, { isLoading }] = useLazyGetAdminsQuery();

  const [state, setState] = useState(initialState);
  const [pagination, setPagination] = useState({
    totalPage: 0,
    pageSize: 0,
    currentPage: 0,
    totalElement: 0,
  });
  const [dataTable, setDataTable] = useState({
    columns: tableColumns,
    rows: [],
  });

  const fetchTasks = useCallback(async (params) => {
    const resp = await trigger(params);
    if (resp?.data?.data?.data) {
      setDataTable({
        columns: tableColumns,
        rows: resp.data.data.data.map((item) => {
          return {
            ...item,
            fullName: (
              <MDBox
                className="avatar"
                // onClick={() => handleModalAction(item, "view")}
                sx={{ cursor: "pointer" }}
              >
                <MDBox
                  className="avatar-img"
                  component="img"
                  src={item.avatar ?? AvaImg}
                ></MDBox>
                <span>{item.fullName}</span>
              </MDBox>
            ),
            title: (
              <Tooltip title={item.title}>
                <span
                  style={{
                    cursor: "default",
                    display: "inline-block",
                    maxWidth: "150px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.title}
                </span>
              </Tooltip>
            ),
            centerName: (
              <Tooltip title={item.centerName}>
                <Chip className="chip-center" label={item.centerName} />
              </Tooltip>
            ),
            status: (
              <Chip
                className={`chip-status chip-status-${item.status}`}
                sx={{
                  cursor: "default",
                  background:
                    item.status === "INACTIVE" ? "#FDD1DA" : "#B0EED3",
                  color: item.status === "INACTIVE" ? "#F80031" : "#1AAE6F",
                }}
                label={item.status}
              />
            ),
            action: (
              <MDBox className="action-icon">
                <Edit className="action-icon disabled" />
                <Delete className="action-icon disabled" />
              </MDBox>
            ),
          };
        }),
      });
      setPagination({
        totalPage: resp.data.data.totalPage,
        pageSize: resp.data.data.pageSize,
        currentPage: resp.data.data.currentPage,
        totalElement: resp.data.data.totalElement,
      });
      setState((prev) => ({ ...prev, ...params }));
    }
  }, []);

  const handleSearch = useAsyncDebounce((value) => {
    fetchTasks({ ...state, search: value?.trim() || "", page: 0 });
  }, 1000);

  const handlePageChange = useCallback(
    (page) => {
      fetchTasks({ ...state, page });
    },
    [state, fetchTasks]
  );

  const handleFilterChange = useCallback(
    (key, e) => {
      const value = e?.value || e;
      fetchTasks({ ...state, [key]: value, page: 0 });
    },
    [state, fetchTasks]
  );

  const advanceTableProps = {
    columns: dataTable.columns,
    rows: dataTable.rows,
    filters: [
      {
        key: "search",
        label: "Search here",
        value: state.search,
        type: "text",
        startAdornment: (
          <InputAdornment position="start">
            <Search className="icon-search" />
          </InputAdornment>
        ),
        onChange: (e) => handleSearch(e.target.value),
      },
    ],
    pagination,
    onPageChange: handlePageChange,
    onFilterChange: handleFilterChange,
    totalElements: pagination.totalElement,
  };

  useEffect(() => {
    fetchTasks(initialState);
  }, [fetchTasks]);

  return (
    <DashboardLayout>
      <AdminHeader />
      <DashboardNavbar light />
      {isLoading ? (
        <MDBox className="container-lxo-management">
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height={300}
          >
            <Loading style={{ width: 150, height: 100 }} />
          </MDBox>
        </MDBox>
      ) : (
        <MDBox className="container-lxo-management">
          <MDBox className="header-lxo-task">
            <MDBox className="group-title">
              <MDTypography className="title">Admin Management</MDTypography>
            </MDBox>
            <MDBox className="group-btn">
              {/* <Button
                className="btn btn-create"
                variant="contained"
                startIcon={<Add />}
                onClick={() => handleModalAction(null, "create")}
              >
                Create new
              </Button> */}
            </MDBox>
          </MDBox>
          <MDBox className="content-lxo-task">
            <AdvanceTable {...advanceTableProps} />
          </MDBox>
        </MDBox>
      )}
    </DashboardLayout>
  );
}
